import { render, staticRenderFns } from "./CompHouseCard.vue?vue&type=template&id=005f0caf&scoped=true"
import script from "./CompHouseCard.vue?vue&type=script&lang=js"
export * from "./CompHouseCard.vue?vue&type=script&lang=js"
import style0 from "./CompHouseCard.vue?vue&type=style&index=0&id=005f0caf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_css-loader@6.11.0_webpack@5.109.2_postcss@8_d337a9d5bbcfbb759141208e4b3c712e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005f0caf",
  null
  
)

export default component.exports